import { render, staticRenderFns } from "./AbilityCategory.vue?vue&type=template&id=a31558e2&scoped=true"
import script from "./AbilityCategory.vue?vue&type=script&lang=js"
export * from "./AbilityCategory.vue?vue&type=script&lang=js"
import style0 from "./AbilityCategory.vue?vue&type=style&index=0&id=a31558e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31558e2",
  null
  
)

export default component.exports